// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__3IxOs","tab":"Tabs_tab__1GcRY","tabActive":"Tabs_tabActive__Hk_jV"};